import { Inject, Injectable, Injector } from '@angular/core';
import { concat, find, isString } from 'lodash';

import { IServiceClass } from './service.types';

@Injectable()
export class ServiceProvider {
  public constructor(
    public injector: Injector,
    @Inject('EntityServices') public entityServices,
    @Inject('UtilityServices') public utilityServices,
  ) {}

  public get services(): IServiceClass[] {
    return concat(this.entityServices, this.utilityServices);
  }

  public getServiceClass(predicate: any): IServiceClass {
    if (!isString(predicate)) {
      return find(this.services, predicate);
    }

    return (find(this.services, { ENTITY_TYPE: predicate }) ||
      find(this.services, { serviceIdentifyType: predicate }) ||
      find(this.services, { name: predicate })) as IServiceClass;
  }

  public getService<R extends IServiceClass>(
    predicate: any,
    notFoundValue?,
  ): R {
    const serviceClass = this.getServiceClass(predicate);
    const service = this.injector.get(serviceClass, notFoundValue);

    return service;
  }
}
